import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    AssetsSingleTileContainer: () => import("./components/AssetsSingleTileContainer.vue"),

    MaterialsIframe: () => import("./components/tiles/oldMaterials/MaterialsIframe.vue"),
    DocumentIframe: () => import("./components/tiles/documents/DocumentIframe.vue"),

    AssetsMenu: () => import("./components/tiles/assetsMenu/AssetsMenuTile.vue"),

    WarehouseListContainer: () => import("./components/tiles/warehouse/WarehouseListContainer.vue"),
    WarehouseHome: () => import("./components/tiles/warehouse/WarehouseHomeTile.vue"),
    WarehouseDetail: () => import("./components/tiles/warehouse/WarehouseDetailTile.vue"),
    WarehouseAdd: () => import("./components/tiles/warehouse/WarehouseAddTile.vue"),

    ProductDocumentList: () => import("./components/tiles/documents/ProductDocumentList.vue"),

    FertilizerListContainer: () => import("./components/tiles/fertilizer/FertilizerListContainer.vue"),
    FertilizerList: () => import("./components/tiles/fertilizer/FertilizerListTile.vue"),
    FertilizerDetail: () => import("./components/tiles/fertilizer/FertilizerDetailTile.vue"),
    FertilizerWarehouseAdd: () => import("./components/tiles/fertilizer/FertilizerWarehouseAddTile.vue"),
    FertilizerWarehouseLoad: () => import("./components/tiles/fertilizer/FertilizerWarehouseLoadTile.vue"),
    FertilizerEdit: () => import("./components/tiles/fertilizer/FertilizerEditTile.vue"),

    FuelListContainer: () => import("./components/tiles/fuel/FuelListContainer.vue"),
    FuelList: () => import("./components/tiles/fuel/FuelListTile.vue"),
    FuelDetail: () => import("./components/tiles/fuel/FuelDetailTile.vue"),
    FuelWarehouseAdd: () => import("./components/tiles/fuel/FuelWarehouseAddTile.vue"),
    FuelWarehouseLoad: () => import("./components/tiles/fuel/FuelWarehouseLoadTile.vue"),
    FuelEdit: () => import("./components/tiles/fuel/FuelEditTile.vue"),

    ElectricityListContainer: () => import("./components/tiles/electricity/ElectricityListContainer.vue"),
    ElectricityList: () => import("./components/tiles/electricity/ElectricityListTile.vue"),
    ElectricityDetail: () => import("./components/tiles/electricity/ElectricityDetailTile.vue"),
    ElectricityWarehouseAdd: () => import("./components/tiles/electricity/ElectricityWarehouseAddTile.vue"),
    ElectricityWarehouseLoad: () => import("./components/tiles/electricity/ElectricityWarehouseLoadTile.vue"),
    ElectricityEdit: () => import("./components/tiles/electricity/ElectricityEditTile.vue"),

    PhytochemicalListContainer: () => import("./components/tiles/phytochemical/PhytochemicalListContainer.vue"),
    PhytochemicalList: () => import("./components/tiles/phytochemical/PhytochemicalListTile.vue"),
    PhytochemicalDetail: () => import("./components/tiles/phytochemical/PhytochemicalDetailTile.vue"),
    PhytochemicalWarehouseAdd: () => import("./components/tiles/phytochemical/PhytochemicalWarehouseAddTile.vue"),
    PhytochemicalWarehouseLoad: () => import("./components/tiles/phytochemical/PhytochemicalWarehouseLoadTile.vue"),
    PhytochemicalEdit: () => import("./components/tiles/phytochemical/PhytochemicalEditTile.vue"),

    SeedListContainer: () => import("./components/tiles/seed/SeedListContainer.vue"),
    SeedList: () => import("./components/tiles/seed/SeedListTile.vue"),
    SeedDetail: () => import("./components/tiles/seed/SeedDetailTile.vue"),
    SeedWarehouseAdd: () => import("./components/tiles/seed/SeedWarehouseAddTile.vue"),
    SeedWarehouseLoad: () => import("./components/tiles/seed/SeedWarehouseLoadTile.vue"),
    SeedEdit: () => import("./components/tiles/seed/SeedEditTile.vue"),

    ProductListContainer: () => import("./components/tiles/product/ProductListContainer.vue"),
    ProductList: () => import("./components/tiles/product/ProductListTile.vue"),
    ProductDetail: () => import("./components/tiles/product/ProductDetailTile.vue"),
    ProductWarehouseAdd: () => import("./components/tiles/product/ProductWarehouseAddTile.vue"),
    ProductWarehouseLoad: () => import("./components/tiles/product/ProductWarehouseLoadTile.vue"),
    ProductEdit: () => import("./components/tiles/product/ProductEditTile.vue"),

    WaterListContainer: () => import("./components/tiles/water/WaterListContainer.vue"),
    WaterList: () => import("./components/tiles/water/WaterListTile.vue"),
    WaterDetail: () => import("./components/tiles/water/WaterDetailTile.vue"),
    WaterWarehouseAdd: () => import("./components/tiles/water/WaterWarehouseAddTile.vue"),
    WaterWarehouseLoad: () => import("./components/tiles/water/WaterWarehouseLoadTile.vue"),
    WaterEdit: () => import("./components/tiles/water/WaterEditTile.vue"),

    EquipmentTemplate: () => import("./components/tiles/equipments/EquipmentTemplate.vue"),
    EquipmentListContainer: () => import("./components/tiles/equipments/EquipmentMenuTileset.vue"),
    EquipmentList: () => import("./components/tiles/equipments/equipment/EquipmentList.vue"),

    BuildingTemplate: () => import("./components/tiles/buildings/BuildingTemplate.vue"),
    BuildigListContainer: () => import("./components/tiles/buildings/BuildingMenuTileset.vue"),
    BuildingList: () => import("./components/tiles/buildings/building/BuildingList.vue"),

    WorkerTileset: () =>  import("./components/tiles/worker/WorkerTileset.vue"),
    WorkerTeamList: () => import("./components/tiles/worker/team/WorkerTeamList.vue"),
    WorkerTeamEdit: () => import("./components/tiles/worker/team/WorkerTeamEdit.vue"),

    TraceabilityContainer: () => import("./components/tiles/traceability/TraceabilityContainer.vue"),
    LotTraceability: () => import("./components/tiles/traceability/index.vue"),

    AssetsMovementsTile: () => import("./components/tiles/movement/AssetsMovementsTile.vue"),
    AssetsMovementEditTile: () => import("./components/tiles/movement/AssetsMovementEditTile.vue"),

    StaffListTile: () => import("./components/tiles/staff/StaffListTile.vue"),

    // PUBLIC CHARTS
    "WorkShiftsChartTile": {
        meta: {
            i18nDescrKey: "employee-stampings",
            filters: ["farm-select-nav-bar-item"],
            pinnable: true,
            tag: "TIMESHEET"
        },
        component: () => import("./components/tiles/charts/workshift/WorkShiftsChartTile.vue")
    },
    "ElectricityConsumptionChartTile": {
        meta: {
            i18nDescrKey: "electricity-consumption",
            filters: ["farm-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD_PORTAL"
        },
        component: () => import("./components/tiles/charts/ElectricityConsumptionChartTile.vue")
    },

};

export default globals;
